/**
 * 承诺方向解析（A+B 方向模型核心）。
 *
 * 轿厢到达楼层 F 时，依据「前方同向工作 / 本层同向候梯」决定承诺方向：
 * - 维持当前方向，只要有同向工作（前方或本层）；
 * - 否则折返到反方向（若反方向有工作）；
 * - 都没有则置 0（将进入空闲）。
 *
 * 方向感知上客据此 gate：只接与承诺方向同向的乘客，反向乘客等折返或换车。
 * 纯函数，便于单测；确定性（无随机/系统时钟）。
 */

/** 1=上行，-1=下行，0=空闲/无方向。 */
export type Dir = 1 | -1 | 0;

/**
 * @param cur 当前承诺方向（到达时的运行方向，或空闲为 0）
 * @param upAhead 前方（高于 F）有同向工作：轿内目的层在上，或指派的上行呼叫在上
 * @param downAhead 前方（低于 F）有同向工作
 * @param upHere 本层有指派的上行候梯乘客
 * @param downHere 本层有指派的下行候梯乘客
 */
export function resolveBoardingDirection(
  cur: Dir,
  upAhead: boolean,
  downAhead: boolean,
  upHere: boolean,
  downHere: boolean,
): Dir {
  const upWork = upAhead || upHere;
  const downWork = downAhead || downHere;
  if (cur === 1) return upWork ? 1 : downWork ? -1 : 0;
  if (cur === -1) return downWork ? -1 : upWork ? 1 : 0;
  // cur === 0（空闲到达）
  if (upWork && !downWork) return 1;
  if (downWork && !upWork) return -1;
  if (upWork && downWork) return 1; // 确定性 tie → 上行
  return 0;
}
